function initToShow() {
    if ($('.js-to-show').length) {
        setIntersections('', '.js-to-show.not-init', '0px 0px 0px 0px')
    }
}